import { useState } from 'react';
import { testimonials } from '@/mocks/soniem';

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);
  const total = testimonials.length;

  const goTo = (index: number) => {
    setCurrent((index + total) % total);
  };

  const testimonial = testimonials[current];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-600 mb-3">
              Testimonios
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
              Lo que dicen nuestros{' '}
              <span className="text-primary-500">artistas</span>
            </h2>
          </div>

          {/* Testimonial Card */}
          <div className="relative bg-background-50 rounded-3xl p-8 md:p-12 border border-secondary-200/60 transition-all duration-500">
            {/* Quotation marks */}
            <div className="absolute top-6 left-6 md:top-10 md:left-10">
              <i className="ri-double-quotes-l text-5xl md:text-7xl text-primary-100" />
            </div>

            {/* Rating */}
            <div className="flex items-center gap-1 mb-6">
              {Array.from({ length: testimonial.rating }).map((_, i) => (
                <i key={i} className="ri-star-fill text-primary-500 text-lg" />
              ))}
            </div>

            {/* Quote */}
            <blockquote className="relative z-10 mb-8">
              <p className="font-heading text-lg md:text-xl lg:text-2xl text-foreground-800 leading-relaxed italic">
                &ldquo;{testimonial.quote}&rdquo;
              </p>
            </blockquote>

            {/* Author */}
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-full overflow-hidden flex-shrink-0 border-2 border-primary-100">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="font-semibold text-foreground-900 text-sm md:text-base">
                  {testimonial.name}
                </p>
                <p className="text-foreground-500 text-xs md:text-sm">
                  {testimonial.role}
                </p>
              </div>
            </div>

            {/* Navigation */}
            <div className="absolute bottom-8 right-8 md:bottom-12 md:right-12 flex items-center gap-3">
              <button
                onClick={() => goTo(current - 1)}
                className="w-10 h-10 md:w-11 md:h-11 rounded-full flex items-center justify-center bg-secondary-100 text-foreground-700 hover:bg-foreground-900 hover:text-white transition-all duration-300 cursor-pointer"
                aria-label="Testimonio anterior"
              >
                <i className="ri-arrow-left-line text-lg" />
              </button>
              <button
                onClick={() => goTo(current + 1)}
                className="w-10 h-10 md:w-11 md:h-11 rounded-full flex items-center justify-center bg-foreground-900 text-white hover:bg-primary-500 transition-all duration-300 cursor-pointer"
                aria-label="Siguiente testimonio"
              >
                <i className="ri-arrow-right-line text-lg" />
              </button>
            </div>

            {/* Dots */}
            <div className="flex items-center justify-center gap-2 mt-8 pt-2">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrent(i)}
                  className={`transition-all duration-300 rounded-full cursor-pointer ${
                    i === current
                      ? 'w-6 h-2 bg-primary-500'
                      : 'w-2 h-2 bg-secondary-300 hover:bg-secondary-400'
                  }`}
                  aria-label={`Ir al testimonio ${i + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}